import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import styled from 'styled-components'

export const StyledExternalCostTypeFieldBox = styled(FormFieldBox)`
    height: 32px;
`
